<template>
  <v-dialog :model-value="show" max-width="400">
    <v-card>
      <v-card-title class="text-h6">{{ title }}</v-card-title>
      <v-card-text>{{ message }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="handleEvent('cancel')">Cancel</v-btn>
        <v-btn color="green" @click="handleEvent('confirm')">Confirm</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default{
    name: 'ConfirmationDialog',
    props:{
        show: Boolean,
        message: String,
    },
    data(){
        return{
            title: 'Confirm Action',
        }
    },
    methods:{
      handleEvent(action){
        this.$emit('confirmationEvent',action)
      }
    }
}
</script>
